
import { useNavigate } from "react-router-dom";

// --- Done Screen ---
function DoneScreen({resetData}) {
  const navigate = useNavigate()

  function startOver(){
    resetData()
    navigate('/')
  }

  return (
    <div className="screen active">
      <h1>Submission Complete</h1>
      <p>
        Thank you for completing the survey.
      </p>
      <button onClick={startOver}>Start Over</button>
    </div>
  );
}


export default DoneScreen